import { useEffect, useState, useContext, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Contexto } from "./../App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _btn_ from "@Elementos/Boton";
import * as _ipt_ from "@Elementos/Input";
import * as _anim_ from "@Elementos/Animaciones";
import Logo from "@Imagenes/Logo.png";
import "./InicioSesion.css";

const URL_COMPROBACION = "https://api.panificadorasanmiguel.com/comprobar-conexion/";

function useOnlineStatus() {
  const [estadoConexion, setEstadoConexion] = useState("comprobando");

  const comprobarConexion = useCallback(async () => {
    if (!navigator.onLine) {
      setEstadoConexion("desconectado");
      return;
    }

    setEstadoConexion("comprobando");

    const controlador = new AbortController();
    const temporizador = setTimeout(
      () => controlador.abort(),
      5000
    );

    try {
      const respuesta = await fetch(URL_COMPROBACION, {
        method: "GET",
        cache: "no-store",
        signal: controlador.signal,
      });

      if (!respuesta.ok) {
        throw new Error("El servidor no responde correctamente");
      }

      setEstadoConexion("conectado");
    } catch {
      setEstadoConexion("desconectado");
    } finally {
      clearTimeout(temporizador);
    }
  }, []);

  useEffect(() => {
    const alConectar = () => {
      comprobarConexion();
    };

    const alDesconectar = () => {
      setEstadoConexion("desconectado");
    };

    window.addEventListener("online", alConectar);
    window.addEventListener("offline", alDesconectar);

    comprobarConexion();

    return () => {
      window.removeEventListener("online", alConectar);
      window.removeEventListener("offline", alDesconectar);
    };
  }, [comprobarConexion]);

  return estadoConexion;
}

function InicioSesion(args) {

  const estadoConexion = useOnlineStatus();
  let isMounted = true;
  const formRefs = useRef({});
  const { ecv_u, esComputadora, eusuarioSesion, erolUsuarioSesion } = useContext(Contexto);
  const [v_s, ev_s] = useState({});
  const [v_u, ev_u] = useState({
    token: null,
    esperando: false,
  });
  const navigate = useNavigate();
  function iniciarSesion() {
    const codigoUsuario = formRefs.current.usuario.value.toUpperCase();
    const contrasenia = formRefs.current.password.value;
    const { respuesta } = _api_.f_inicioSesion({ parametros: { codigoUsuario, contrasenia }, timeout: 10000 });
    ev_u({ esperando: true });
    respuesta.then((dInicioSesion) => {
      console.log(dInicioSesion);
      ecv_u(dInicioSesion);
      if (!dInicioSesion.error) {
        _f_.establecerCookies("usuario", codigoUsuario);
        _f_.establecerCookies("tokenSesion", dInicioSesion.contenido?.tokenSesion);
        const infoUsuario = _api_.f_obtenerInformacionUsuario(3000);
        infoUsuario.respuesta.then((dInfoUsuario) => {
          ecv_u(dInfoUsuario);
          if (!dInfoUsuario.error) {
            const apePat = dInfoUsuario.contenido.apellidoPaterno;
            const apeMat = dInfoUsuario.contenido.apellidoMaterno;
            const codRol = dInfoUsuario.contenido.codRol;
            const dscRol = dInfoUsuario.contenido.descRol;
            const nomUsu = dInfoUsuario.contenido.nombreUsuario;
            const codUsu = dInfoUsuario.contenido.codUsuario;
            // console.log(dInfoUsuario)
            _f_.establecerCookies("apePaterno", apePat);
            _f_.establecerCookies("apeMaterno", apeMat);
            _f_.establecerCookies("codRol", codRol);
            _f_.establecerCookies("dscRol", dscRol);
            _f_.establecerCookies("nomUsuario", nomUsu);
            ev_u({ esperando: false });
            eusuarioSesion(codUsu);
            erolUsuarioSesion(codRol);
            navigate("/principal");
          } else {
            _f_.eliminarCookies();
            ev_u({ esperando: false });
          }
        });
      } else {
        _f_.eliminarCookies();
        ev_u({ esperando: false });
      }
    });
  }
  useEffect(() => {
    let controlLlamado;
    if (_f_.obtenerCookie("usuario") && _f_.obtenerCookie("tokenSesion")) {
      const resultado = _api_.f_validarSesion({ origen: "IS", timeout: 10000 });
      controlLlamado = resultado.controlLlamado;
      resultado.respuesta.then((dInicioSesion) => {
        ecv_u(dInicioSesion);
        if (!dInicioSesion.error) {
          navigate("/principal");
        }
      });
    } else {
      _f_.eliminarCookies();
    }
    return () => {
      isMounted = false;
      controlLlamado && controlLlamado.abort();
    };
  }, []);

  const registerRef = (name) => (el) => {
    formRefs.current[name] = el;
  };

  return (
    <>
     <div className="app-repair-container">
  <button
    type="button"
    className="app-repair-button"
    onClick={async () => {
      const ejecutarConSeguridad = async (etiqueta, operacion) => {
        try {
          await operacion();
        } catch (error) {
          console.warn(`Error en ${etiqueta}:`, error);
        }
      };

      // 1. Limpiar almacenamiento
      await ejecutarConSeguridad("localStorage", () =>
        localStorage.clear()
      );

      await ejecutarConSeguridad("sessionStorage", () =>
        sessionStorage.clear()
      );

      // 2. Eliminar las cookies indicadas
      const cookiesParaEliminar = [
        "apeMaterno",
        "apePaterno",
        "codRol",
        "cpsession",
        "dscRol",
        "nomUsuario",
        "tokenSesion",
        "usuario",
      ];

      await ejecutarConSeguridad("cookies", () => {
        cookiesParaEliminar.forEach((nombre) => {
          document.cookie =
            `${nombre}=; Max-Age=0; path=/; SameSite=Lax`;

          document.cookie =
            `${nombre}=; Max-Age=0; path=${window.location.pathname}; SameSite=Lax`;
        });
      });

      // 3. Limpiar Cache Storage
      await ejecutarConSeguridad("Cache Storage", async () => {
        if (!("caches" in window)) return;

        const claves = await caches.keys();

        await Promise.all(
          claves.map((clave) => caches.delete(clave))
        );
      });

      // 4. Desregistrar Service Workers
      await ejecutarConSeguridad("Service Workers", async () => {
        if (!("serviceWorker" in navigator)) return;

        const registros =
          await navigator.serviceWorker.getRegistrations();

        await Promise.all(
          registros.map((registro) => registro.unregister())
        );
      });

      // 5. Recargar la aplicación
      window.location.reload();
    }}
  >
    <span className="app-repair-icon" aria-hidden="true">
      ↻
    </span>

    <span>Recargar aplicación</span>
  </button>

  <div
    className={`app-connection-status is-${estadoConexion}`}
    role="status"
    aria-live="polite"
  >
    <span
      className="app-connection-dot"
      aria-hidden="true"
    />

    <span>
      {estadoConexion === "comprobando" && "Comprobando conexión..."}
      {estadoConexion === "conectado" && "Conectado"}
      {estadoConexion === "desconectado" && "Sin conexión"}
    </span>
  </div>
</div>


      <div id={"inicio-sesion"} escomputadora={String(esComputadora)}>
        <div className="inicio-sesion-contenido">
          <div className={"inicio-sesion-marca"}>
            <img src={Logo} className={"inicio-sesion-logo"} />
            <span className={"inicio-sesion-lema"}>Un Gustito que te Bendice</span>
          </div>
          <div className={"inicio-sesion-formulario"}>
            <h1 className={"incio-sesion-formulario-titulo"}>Iniciar Sesión</h1>
            <_ipt_.InputModerno texto="Nombre de Usuario" tipo="text" name="usuario" ref={registerRef("usuario")} />

            <_ipt_.InputModerno texto="Contraseña" tipo="password" name="password" ref={registerRef("password")} />

            <_btn_.Boton
              texto="Ingresar"
              tipo="btn-1"
              onClick={iniciarSesion}
              procesando={v_u.esperando}
              // estilos={{height: "20px"}}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default InicioSesion;
